import SETTINGS from 'actionTypes/settings';
import { WALLET_API } from 'constants/api';
import { SETTINGS_FALLBACK_GITHUB_URL } from 'constants/constants';
import createAction from 'helpers/createAction';

export function getSettings() {
  return {
    types: SETTINGS.GET_SETTINGS,
    shouldSkipAuthHeader: true,
    promise: ({ request }) => request.get(WALLET_API.SETTINGS),
  };
}

export function getSettingsFallbackResp() {
  return {
    types: SETTINGS.GET_SETTINGS_FALLBACK,
    shouldSkipAuthHeader: true,
    promise: ({ request }) => {
      return request.get(SETTINGS_FALLBACK_GITHUB_URL, { useExactUrl: true });
    },
  };
}

export const showMaintenanceBanner = createAction(SETTINGS.SHOW_MAINTENANCE_BANNER);
export const playWithdrawalVideo = createAction(SETTINGS.PLAY_WITHDRAWAL_VIDEO);
export const playDepositVideo = createAction(SETTINGS.PLAY_DEPOSIT_VIDEO);
export const enableServerDegradedModeDisableManagePositionOnlyView = createAction(
  SETTINGS.ENABLE_SERVER_DEGRADED_MODE_DISABLE_DEGRADED_MODE_NOTIFY_VIEW
);
export const updateAppStatus = createAction(SETTINGS.UPDATE_APP_STATUS);
export const startMaintenanceSystemUpdate = createAction(
  SETTINGS.START_MAINTENANCE_SYSTEM_UPDATE
);
export const startMaintenanceSystemScheduled = createAction(
  SETTINGS.START_MAINTENANCE_SYSTEM_SCHEDULED
);
